/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const BullseyePointerRegularV6 = (props) => (
  <Icon {...props} name="Bullseye Pointer Regular V6">
    <path d="M8 14.5c3.591 0 6.5-2.909 6.5-6.5S11.591 1.5 8 1.5a6.499 6.499 0 0 0-6.48 7.009L.055 8.94A8 8 0 0 1 8-.001a8 8 0 0 1 8 8 8 8 0 0 1-8.941 7.944l.431-1.462c.169.012.338.019.509.019zm.372-3.019A3.503 3.503 0 0 0 11.5 8c0-1.934-1.566-3.5-3.5-3.5a3.502 3.502 0 0 0-3.481 3.128l-1.518.447L3 8c0-2.763 2.237-5 5-5s5 2.237 5 5a5 5 0 0 1-5 5c-.025 0-.05-.028-.075-.028l.447-1.491zm-7.153-1.84L7.622 7.76a.492.492 0 0 1 .619.619L6.36 14.754c-.128.462-.725.516-.928.109l-.894-1.791c-.022-.069-.05-.081-.081-.116l-2.749 2.75a.999.999 0 1 1-1.414-1.413l2.75-2.75a.553.553 0 0 0-.115-.081l-1.791-.894a.5.5 0 0 1 .083-.928z" />
  </Icon>
);

export default BullseyePointerRegularV6;
